import { atom } from "jotai";
import { Node } from "@xyflow/react";
import { closeContextMenusAtom } from "../diagramming";
import { updateNodeSetter } from "./updateNodeSetter";
import { addNodeOnClickSetter } from "./addNodeOnClickSetter";

type Params = {
  event: React.MouseEvent;
  node: Node;
  ref: React.MutableRefObject<HTMLDivElement | null>;
  emitEventOnAddStep: (interactionType: string, rawText: string) => void;
  emitEventOnAddPath: (interactionType: string, rawText: string) => void;
  screenToFlowPosition: (point: { x: number; y: number }) => {
    x: number;
    y: number;
  };
  getIntersectingNodes: (rect: {
    x: number;
    y: number;
    width: number;
    height: number;
  }) => Node[];
};

export const onNodeClickSetter = atom(
  null,
  async (
    _get,
    set,
    {
      event,
      node,
      ref,
      emitEventOnAddStep,
      emitEventOnAddPath,
      screenToFlowPosition,
      getIntersectingNodes,
    }: Params,
  ) => {
    // Closes the context menus when user don't need to use them or else they're forced to delete the node
    set(closeContextMenusAtom);

    // When the node's handle is clicked, it propagates an event up to the parent
    // node element. By the time this function is called, `node.selected === true` already
    // so it's too late to stop the propagation. So, let's just set it back to false
    // when the handle is clicked to prevent the node's selected glow and menu from showing.
    if (
      (event.target as HTMLElement).classList.contains("react-flow__handle")
    ) {
      set(updateNodeSetter, {
        id: node.id,
        selected: false,
      });
    }

    // We do this since onPaneClick event is blocked when you click on a group node
    if (node.type === "group") {
      await set(addNodeOnClickSetter, {
        event,
        parentId: node.id,
        ref,
        emitEventOnAddStep,
        emitEventOnAddPath,
        screenToFlowPosition,
        getIntersectingNodes,
      });
    }
  },
);

onNodeClickSetter.debugLabel = "onNodeClickSetter";
